export default "__VITE_ASSET__815ab5e8__"